export const shimmerStyles = {
  WebkitMask:
    "linear-gradient(-60deg, #000 30%, #0005, #000 70%) right/350% 100%",
  mask: "linear-gradient(-60deg, #000 30%, #0005, #000 70%) right/350% 100%",
  WebkitAnimation: "replo-shimmer ease-in-out 2.5s infinite",
  animation: "replo-shimmer 2.5s infinite",
};
